import React from 'react';
import { useSetRecoilState } from 'recoil';
import { ContextMenu } from 'models/ContextMenu';
import contextMenu from 'recoil/atoms/contextMenu';


const useContextMenu = <T>(itemsRenderer?: ContextMenu<T>['itemsRenderer']) => {
    const setContext = useSetRecoilState(contextMenu);

    const openMenu = (e: React.MouseEvent<HTMLElement>, value?: T) => setContext({
        open: true,
        anchorEl: e.currentTarget,
        value,
        itemsRenderer,
    });

    const onContextMenu = (value: T) => (event: React.MouseEvent) => {
        event.preventDefault();

        setContext(old =>
            old === null
                ? {
                    open: true,
                    position: {
                        left: event.clientX - 2,
                        top: event.clientY - 4,
                    },
                    value,
                    itemsRenderer,
                }
                : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
                  // Other native context menus might behave different.
                  // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
                null,
        );
    };

    const closeMenu = () => {
        setContext(old => ({...old, open: false}));
        setTimeout(() => setContext(null), 350);
    };

    return {
        openMenu,
        onContextMenu,
        closeMenu,
    }
};

export default useContextMenu;
